import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { PageComponent } from "@components/page/page.component";
import { ExternVirkeskopService } from "../services/extern-virkeskop.service";
import { ExternVirkeskopSearchPanelComponent } from "./extern-virkeskop-search-panel/extern-virkeskop-search-panel.component";
import { ExternVirkeskopSearchResultComponent } from "./extern-virkeskop-search-result/extern-virkeskop-search-result.component";

@Component({
    selector: "rask-extern-virkeskop-search",
    templateUrl: "./extern-virkeskop-search.component.html",
    styleUrls: ["./extern-virkeskop-search.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        ExternVirkeskopSearchPanelComponent,
        ExternVirkeskopSearchResultComponent,
        ButtonComponent
    ]
})
export class ExternVirkeskopSearchComponent {
    private readonly externVirkeskopService = inject(ExternVirkeskopService);

    protected import(): void {
        if (!this.hasSelected()) {
            return;
        }
        this.externVirkeskopService.import();
    }

    protected download(): void {
        if (!this.hasSelected()) {
            return;
        }
        this.externVirkeskopService.download();
    }

    protected hasSelected(): boolean {
        return this.externVirkeskopService.selected$.value?.length > 0;
    }

    protected hasSelectedWithDokument(): boolean {
        return this.hasSelected() && this.externVirkeskopService.selected$.value.some(x => x.dokument?.length > 0);
    }
}
